function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 1",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M58.91 0a59.28 59.28 0 00-41 101.75l41-42.85z"
}), React.createElement("path", {
  d: "M66.81 3.24h-.48a1.49 1.49 0 00-1.41 1.49V63l-40.58 42.46a1.51 1.51 0 000 2.11A60.79 60.79 0 1066.81 3.24zm0 118.6a57.47 57.47 0 01-39.26-15.39l40-41.77a1.49 1.49 0 00.42-1V6.25a57.8 57.8 0 01-1.11 115.59z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 127.61 124.84"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/trends.svg";
export { SvgComponent as ReactComponent };